import type { TourConfig } from './types';

export const integrationsTour: TourConfig = {
  id: 'integrations-page',
  name: 'Integrations Tour',
  description: 'Learn about available integrations',
  requiredPath: '/dashboard/settings/integrations',
  steps: [
    {
      element: '[data-tour="integrations-header"]',
      popover: {
        title: 'Integrations',
        description:
          'Connect third-party services to enhance your workflow and automate tasks.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="integrations-grid"]',
      popover: {
        title: 'Available Integrations',
        description:
          'Browse and connect available integrations like Google Calendar. Click Connect to get started.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
